<template lang="pug">
  .component-packet-buttons
    .dropdown-buttons
      EditPacketReveal(:item="item")
</template>

<script>
import ActionButton from "../ActionButton";
import ModalReveal from "../../foundation/ModalReveal.vue";
import PacketForm from "../../forms/PacketForm.vue";
import KeplerBackofficeSdk from "../../../../lib/kepler/backoffice";
import MaggieHelper from "../../../../maggieHelper";
import {EventBus} from "../../../../eventBus";
import EditPageReveal from "../../../../pages/backoffice/EditPageReveal.vue";
import EditPacketReveal from "./reveal/EditPacketReveal.vue";

export default {
  name: "PacketButtons",
  components: {EditPacketReveal, EditPageReveal, PacketForm, ModalReveal, ActionButton},
  data() {
    return {
    }
  },
  created() {
  },
  methods: {

  },
  props: ['item']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// PacketButtons.vue?2dc3611c